import { createContext, useContext, useState, useEffect } from 'react';
import { apiRequest } from '@/lib/utils';

const SettingsContext = createContext(null);

// Cache settings in memory to avoid duplicate API calls
let cachedSettings = null;
let settingsPromise = null;

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(cachedSettings);
  const [loading, setLoading] = useState(!cachedSettings);

  useEffect(() => {
    if (cachedSettings) {
      setSettings(cachedSettings);
      setLoading(false);
      return;
    }

    // Dedupe concurrent requests
    if (!settingsPromise) {
      settingsPromise = apiRequest('/settings')
        .then(data => {
          cachedSettings = data;
          return data;
        })
        .catch(err => {
          console.error('Failed to load settings:', err);
          return null;
        })
        .finally(() => {
          settingsPromise = null;
        });
    }

    settingsPromise.then(data => {
      setSettings(data);
      setLoading(false);
    });
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, loading }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  const context = useContext(SettingsContext);
  if (context === undefined) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context || { settings: null, loading: true };
}
